import { render } from "./ApplicationMark.vue?vue&type=template&id=f875d33a"
const script = {}

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__